import type { UserFormValues } from '../types/user-form-values.type';

export const userForm2ApiMapper = ({
  personId,
  email,
  globalRoleIds,
}: UserFormValues) => ({
  personId,
  email: email.trim(),
  globalRoleIds,
});
